import React from 'react';
import {
  DietsFreemiumAccessConnectorApollo,
  FormikRadioInput as Radio,
} from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';
import useSteps from '../StepContext/useSteps';
import { useFormikContext } from 'formik';
import { dietSettings } from '../types';
import { Row, Col } from 'reactstrap';
import DietFreemiumTag from '../components/DietFreemiumTag';

export const DietLevel: React.FC = () => {
  const { t } = useTranslator();
  const { dietLevels } = useSteps();
  const { values } = useFormikContext<dietSettings>();

  return (
    <DietsFreemiumAccessConnectorApollo>
      {({ accessByDietId }) => (
        <>
          <h2 className="mb-4 title-large semi-bold">
            {t('app.nutritionSettings.dietLevel.headline')}
          </h2>

          {dietLevels.map((dietLevel) => {
            if (!dietLevel.renderCondition || dietLevel.renderCondition(values)) {
              return (
                <Radio name="dietLevel" value={dietLevel.value} key={dietLevel.id}>
                  <DietFreemiumTag access={accessByDietId[dietLevel.id]} />
                  <strong>{t(dietLevel.optionTitle)}</strong>
                  <p className="mb-0">{t(dietLevel.optionDescription)}</p>

                  <Row className="mt-m">
                    <Col>
                      <div className="d-flex align-items-start">
                        <div className="bullet protein"></div>
                        <div>
                          <p className="description-small mb-0">
                            {t('settings.dietType.macros.proteins')}
                          </p>
                          <p className="small mb-0">{dietLevel?.macro?.protein}%</p>
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <div className="d-flex align-items-start">
                        <div className="bullet fat"></div>
                        <div>
                          <p className="description-small mb-0">
                            {t('settings.dietType.macros.fats')}
                          </p>
                          <p className="small mb-0">{dietLevel?.macro?.fat}%</p>
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <div className="d-flex align-items-start">
                        <div className="bullet carbs"></div>
                        <div>
                          <p className="description-small mb-0">
                            {t('settings.dietType.macros.carbs')}
                          </p>
                          <p className="small mb-0">{dietLevel?.macro?.carbs}%</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Radio>
              );
            }
            return null;
          })}

          <p className="description text-start mt-xxl mb-xxl text-text-variant-2-color">
            {t('nutritionSettings.dietType.macrosDescription')}
          </p>
        </>
      )}
    </DietsFreemiumAccessConnectorApollo>
  );
};

export default DietLevel;
